
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M23 5a2 2 0 012 2v18a2 2 0 01-2 2H9a2 2 0 01-2-2V7a2 2 0 012-2h14zm1 5H8v15a1 1 0 00.883.993L9 26h14a1 1 0 00.993-.883L24 25V10zm-3 2a1 1 0 011 1v10a1 1 0 01-1 1H11a1 1 0 01-1-1V13a1 1 0 011-1h10zm0 1H11v10h10V13zm-5.714 2.25a.5.5 0 01.05.64l-.058.068-.434.424a.89.89 0 00.004 1.258c.707.702.756 1.818.14 2.578l-.116.13-.513.53a.5.5 0 01-.775-.627l.057-.07.514-.53a.927.927 0 00.07-1.208l-.082-.094a1.89 1.89 0 01-.124-2.544l.135-.147.425-.415a.5.5 0 01.707.008zm3 0a.5.5 0 01.05.64l-.058.068-.434.424a.89.89 0 00.004 1.258c.707.702.756 1.818.14 2.578l-.116.13-.513.53a.5.5 0 01-.775-.627l.057-.07.514-.53a.927.927 0 00.07-1.208l-.082-.094a1.89 1.89 0 01-.124-2.544l.135-.147.425-.415a.5.5 0 01.707.008zM23 6H9a1 1 0 00-.993.883L8 7v2h16V7a1 1 0 00-.883-.993L23 6zM10.5 7a.5.5 0 110 1 .5.5 0 010-1zm2 0a.5.5 0 110 1 .5.5 0 010-1zm2 0a.5.5 0 110 1 .5.5 0 010-1zm5 0a.5.5 0 110 1 .5.5 0 010-1zm2 0a.5.5 0 110 1 .5.5 0 010-1z"}})])
          )
        }
      }
    